export default __webpack_public_path__ + "be9bc045c9bf9e332c7fced2eb82cbb4.gif";